import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { isTranslatedDomain } from './i18n/utils';

import en from './locales/en/common.json';
import es from './locales/es/common.json';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)

function resolveLanguageFromBrowser() {
    const supportedLanguages = ['en', 'es'];
    const browserLanguages = navigator.languages?.length
        ? navigator.languages
        : [navigator.language];

    for (const lang of browserLanguages) {
        const normalized = lang.toLowerCase().split('-')[0];

        if (supportedLanguages.includes(normalized)) {
            return normalized;
        }
    }

    // default
    return 'en';
}

function resolveInitialLanguage() {
    if (!isTranslatedDomain()) {
        return 'en';
    }

    const stored = localStorage.getItem('preferredLanguage');
    if (stored) {
        return stored;
    }

    return resolveLanguageFromBrowser();
}

const language = resolveInitialLanguage();

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources: {
            en: { translation: en },
            es: { translation: es }
        },
        lng: language,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

if (isTranslatedDomain()) {
    i18n.on('initialized', () => {
        document.documentElement.lang = i18n.language;
    });

    i18n.on('languageChanged', (lng) => {
        document.documentElement.lang = lng;
    });
}

export default i18n;
